export default "__VITE_ASSET__83580bd7__"